import {getAPI , postAPI} from '../../api/apis';
import { REACT_APP_CANDIDATE  } from '../../../src/utils/common'

export async function getInuranceDetails(candidateLoginId: string) {
    const Details = getAPI(REACT_APP_CANDIDATE + `/candidate-insurance/${candidateLoginId}`)
    return Details
}

export async function submitInsuranceDetails(body: any) {
    const Details = postAPI(REACT_APP_CANDIDATE + '/candidate-insurance',body)
    return Details
}